const PREFIX = 'savedCompany#';

/** Exported for prefix Queries (e.g. the alert matcher listing a user's follows). */
export const SAVED_COMPANY_ITEM_KEY_PREFIX = PREFIX;

/** companyId PKs are case-sensitive — never lowercase them (see documentation/SEEKER_HUB_PLAN.md). */
export function buildSavedCompanyItemKey(companyId: string): `savedCompany#${string}` {
  return `${PREFIX}${companyId}`;
}

/** Extracts the companyId from a `savedCompany#{id}` UserState item key, case preserved. Null if malformed. */
export function parseSavedCompanyItemKey(itemKey: string): string | null {
  if (!itemKey.startsWith(PREFIX) || itemKey.length <= PREFIX.length) return null;
  return itemKey.slice(PREFIX.length);
}
